export const transformImage = (
  image: string,
  sizes: string,
  removeFit?: boolean,
  _webP?: boolean
) => {
  if (image) {
    image = image
      .replace(":format(webp)", "")
      .replace("resize:fit", "resize:fill");
    if (removeFit) {
      image = image.replace("full-fit-in/", "").replace("fit-in/", "");
    }
    return image.replace("[W]x[H]/", sizes + "/");
  }
  return "";
};
